<template>
    <!-- Paiement Klarna en 3 fois : lien de paiement envoyé au client (35 € minimum restant) -->
    <div class="ckp-remote">
        <div class="ckp-remote-name">
            <strong>Klarna</strong>
            <small>3 × {{ formatPrice(remaining / 3) }}</small>
        </div>
        <p class="ckp-remote-help">{{ remaining < 35 ? 'Disponible à partir de 35 € restant dû.' : 'Le client reçoit un lien de paiement par email.' }}</p>
        <div class="ckp-remote-action">
            <button type="button" class="ck-button" :disabled="remaining < 35 || loadingPreleve" @click="preleverKlarna">
                {{ loadingPreleve ? 'Envoi…' : 'Payer en 3 fois' }}
            </button>
        </div>
        <p v-if="errorPrelever" class="ckp-note is-error">{{ errorPrelever }}</p>
    </div>
</template>
<style>
.clientCards .v-input__slot {
    border-radius: 10px;
}
</style>
<script>
import axios from 'axios'
export default {
    props: ['userId', 'orderId','currentOrder'],
    computed: {
        // Reste dû de la commande
        remaining() {
            return Math.max(0, parseFloat(this.currentOrder?.total_price || 0) - parseFloat(this.currentOrder?.current_price || 0))
        },
    },
    data: () => {
        return {
            menu: false,
            cartNum: null,
            expire: null,
            cvv: null,
            loadingAddCart: false,
            clientCards: [],
            selectCard: null,
            loadingPreleve: false,
            errorPrelever: null,
            amount: 0
        }
    },
    methods: {
        formatPrice(value) {
            return Number(value || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })
        },
        async preleverKlarna() {
            this.errorPrelever = null
            this.loadingPreleve = true
            axios
                .post(
                    `/back-office/caisse/payByklarna`,
                    {

                        userId: this.userId,
                        orderId: this.orderId,
                        amount: this.currentOrder.total_price - this.currentOrder.current_price
                    },
                    { withCredentials: true }
                )
                .then((res) => {
                    window.location.href=res.data.url
                })
                .catch(error => {
                    this.errorPrelever = error?.response?.data?.message || 'Une erreur est survenue'
                })
                .finally(() => {
                    this.loadingPreleve = false
                })
        },
    },
}
</script>
